function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendNote = function SvgSendNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    stroke: "#2E3330",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M11.9333 4H13.2C13.4122 4 13.6157 4.07726 13.7657 4.21479C13.9157 4.35232 14 4.53884 14 4.73333V10.2964C14 10.4908 13.9157 10.6771 13.7659 10.8146L10.1841 14.7854C10.0342 14.9228 9.83082 15 8.8688 15H2.8C2.58783 15 2.38434 14.9227 2.23431 14.7852C2.08429 14.6477 2 14.4612 2 14.2667V4.73333C2 4.53884 2.08429 4.35232 2.23431 4.21479C2.38434 4.07726 2.58783 4 2.8 4H4.06667",
    stroke: props.fill,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M9.5 14.5V11.2289C9.5 11.0356 9.58381 10.8502 9.73299 10.7135C9.88217 10.5768 10.0845 10.5 10.2955 10.5H13.5",
    stroke: props.fill,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M8.01166 8L8.01166 1M8.01166 1L10 2.8017M8.01166 1L6 2.82523",
    stroke: props.fill,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgSendNote;